<div class="form-row row">
  <div class="form-group col-4">
    <label for="startTime" class="form-label">{{ translationPrefix + '.start-time' | translate }}</label>
    <input id="startTime" type="time" class="form-control" [value]="getStartTime()" disabled>
  </div>
  <div class="form-group col-4">
    <label for="duration" class="form-label">{{ translationPrefix + '.duration' | translate }}</label>
    <app-duration-input id="duration"
                        name="duration"
                        [maxDuration]="maxDurationMinutes"
                        [formControl]="durationControl"></app-duration-input>
  </div>
  <div class="form-group col-4">
    <label for="endTime" class="form-label">{{ translationPrefix + '.end-time' | translate }}</label>
    <input id="endTime" type="time" class="form-control" [value]="getEndTime()" disabled>
  </div>
</div>

<div class="form-row row">
  <div class="form-group col-6">
    <div class="d-flex justify-content-start">
      <button type="button" class="btn btn-primary me-2" (click)="addMinutesToDuration(-60)">-1 h</button>
      <button type="button" class="btn btn-primary" (click)="addMinutesToDuration(-5)">-5 min</button>
    </div>
  </div>
  <div class="form-group col-6">
    <div class="d-flex justify-content-end">
      <button type="button" class="btn btn-primary me-2" (click)="addMinutesToDuration(5)">+5 min</button>
      <button type="button" class="btn btn-primary" (click)="addMinutesToDuration(60)">+1 h</button>
    </div>
  </div>
</div>
